module.exports = __webpack_public_path__ + "static/media/cake.d8678b64.png";